import type { RouteRecordRaw } from 'vue-router';
export const ehsRoutes: RouteRecordRaw[] = [
  {
    path: 'ehs/compliance',
    name: 'ehs-compliance',
    component: () => import('../pages/ehs/EhsPage.vue'),
    meta: { requiresModule: 'ehs' },
  },
];
